export default __webpack_public_path__ + "static/media/post-course.000872b1.png";